module.exports = __webpack_public_path__ + "img/brand-tech-events.0dca1a3f.svg";